import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import GroupPhotoService from "services/GroupPhotoService";

export const getGroupPhotos = createAsyncThunk(
  "groupPhoto/getGroupPhotos",
  async (params, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.getGroupPhotos(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getPosePackages = createAsyncThunk(
  "groupPhoto/getPosePackages",
  async (params, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.getPosePackages(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadGroupPhotoExcel = createAsyncThunk(
  "groupPhoto/downloadGroupPhotoExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.downalodGroupPhotosExcel(
        data,
        params
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSingleGroupPhoto = createAsyncThunk(
  "groupPhoto/getSingleGroupPhoto",
  async (params, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.getSingleGroupPhoto(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const addGroupPhoto = createAsyncThunk(
  "groupPhoto/addGroupPhoto",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.addGroupPhoto(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add groupPhoto"
      );
    }
  }
);

export const editGroupPhoto = createAsyncThunk(
  "groupPhoto/editGroupPhoto",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.editGroupPhoto(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editGroupPhotoType = createAsyncThunk(
  "groupPhoto/editGroupPhotoType",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.editGroupPhotoType(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const addGroupPhotoType = createAsyncThunk(
  "groupPhoto/addGroupPhotoType",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.addGroupPhotoType(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add groupPhoto"
      );
    }
  }
);
export const getGroupPhotoTypes = createAsyncThunk(
  "groupPhoto/getGroupPhotoTypes",
  async (params, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.getGroupPhotoType(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const deleteGroupPhoto = createAsyncThunk(
  "groupPhoto/deleteGroupPhoto",
  async (data, { rejectWithValue }) => {
    try {
      const response = await GroupPhotoService.deleteGroupPhoto(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editGroupPhotoStatus = createAsyncThunk(
  "groupPhoto/editGroupStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      console.log("Data:", data, "Status:", status);
      const response = await GroupPhotoService.editGroupStatus(data, status);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editGroupPhotoTypeStatus = createAsyncThunk(
  "groupPhoto/editGroupPhotoTypeStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      console.log("Data:", data, "Status:", status);
      const response = await GroupPhotoService.editGroupTypeStatus(
        data,
        status
      );
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

const groupPhotoSlice = createSlice({
  name: "groupPhotos",
  initialState: {
    groupPhotos: {},
    groupPhotoTypes: {},
    singleGroupPhoto: {},
    posePackages: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPosePackages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPosePackages.fulfilled, (state, action) => {
        state.loading = false;
        state.posePackages = action.payload;
      })
      .addCase(getPosePackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getGroupPhotos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupPhotos.fulfilled, (state, action) => {
        state.loading = false;
        state.groupPhotos = action.payload;
      })
      .addCase(getGroupPhotos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadGroupPhotoExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadGroupPhotoExcel.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(downloadGroupPhotoExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getGroupPhotoTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupPhotoTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.groupPhotoTypes = action.payload;
      })
      .addCase(getGroupPhotoTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSingleGroupPhoto.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleGroupPhoto.fulfilled, (state, action) => {
        state.loading = false;
        state.singleGroupPhoto = action.payload;
      })
      .addCase(getSingleGroupPhoto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addGroupPhoto.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addGroupPhoto.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addGroupPhoto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addGroupPhotoType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addGroupPhotoType.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addGroupPhotoType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editGroupPhoto.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editGroupPhoto.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editGroupPhoto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editGroupPhotoType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editGroupPhotoType.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editGroupPhotoType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editGroupPhotoStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editGroupPhotoStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editGroupPhotoStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editGroupPhotoTypeStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editGroupPhotoTypeStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editGroupPhotoTypeStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = groupPhotoSlice.actions;
export default groupPhotoSlice.reducer;
